import { render, staticRenderFns } from "./ProjectsListView.vue?vue&type=template&id=79cd4830&"
import script from "./ProjectsListView.vue?vue&type=script&lang=js&"
export * from "./ProjectsListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports